import Actions from '@apps/automation/admin/components/actions'
import Container from '@admin/components/container'
import Comments from '@admin/components/comments'
import Button from '@admin/components/button'
import PropTypes from 'prop-types'
import React from 'react'

class Participant extends React.PureComponent {

  static propTypes = {
    actions: PropTypes.object,
    activity: PropTypes.object,
    enrollment: PropTypes.object,
    participant: PropTypes.object,
    workflow: PropTypes.object,
    webinar: PropTypes.object
  }

  render() {
    const { enrollment, participant } = this.props
    return (
      <div className="crm-timeline-card-section">
        <div className="crm-timeline-card-section-body">
          <table className="ui celled compact unstackable table">
            <tbody>
              <tr>
                <td>Webinar</td>
                <td><Button { ...this._getWebinar() } /></td>
              </tr>
              <tr>
                <td>Participant</td>
                <td><Button { ...this._getParticipant() } /></td>
              </tr>
              { enrollment &&
                <tr>
                  <td>Enrollment</td>
                  <td><Button { ...this._getEnrollment() } /></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div className="crm-timeline-card-section-footer">
          { enrollment &&
            <Actions { ...this._getActions() } />
          }
          <Comments entity={`truevail_participants/${participant.id}`} />
        </div>
      </div>
    )
  }

  _getActions() {
    const { actions, enrollment, workflow } = this.props
    return {
      enrollment,
      actions,
      trigger: workflow.trigger
    }
  }

  _getEnrollment() {
    const { enrollment, workflow } = this.props
    return {
      label: 'View Enrollment',
      className: 'link',
      route: `/admin/automation/workflows/${workflow.id}/enrollments/${enrollment.id}`
    }
  }

  _getParticipant() {
    const { participant, webinar } = this.props
    return {
      label: 'View Participant',
      className: 'link',
      route: `/admin/truevail/admin/webinars/${webinar.id}/participants/${participant.id}`
    }
  }

  _getWebinar() {
    const { webinar } = this.props
    return {
      label: webinar.title,
      className: 'link',
      route: `/admin/truevail/admin/webinars/${webinar.id}`
    }
  }

}

const mapResources = (props, context) => ({
  webinar: `/api/admin/truevail/admin/webinars/${props.activity.data.webinar_id}`,
  participant: `/api/admin/truevail/admin/webinars/${props.activity.data.webinar_id}/participants/${props.activity.data.participant_id}`,
  ...props.activity.data.enrollment_id ? {
    actions: `/api/admin/automation/workflows/${props.activity.data.workflow_id}/enrollments/${props.activity.data.enrollment_id}/actions`,
    enrollment: `/api/admin/automation/workflows/${props.activity.data.workflow_id}/enrollments/${props.activity.data.enrollment_id}`,
    workflow: `/api/admin/automation/workflows/${props.activity.data.workflow_id}`  
  } : {}


})

export default Container(mapResources)(Participant)
